/*eslint-disable*/
import { useState, useEffect } from "react";

// services
import { fetchUser } from '../../services/user';

const useUser = (userId) => {
    const [user, setUser] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const getUser =async () => {
        try {
            const {data: userResponse } = await fetchUser(userId) || {};
            setUser(userResponse);
          } catch (error) {
            //toast.error(error.message)
          } finally {
            setIsLoading(false)
          }
    };

    useEffect(() => {
        getUser()
    }, []);

    

    return { user, isUserLoading: isLoading, getUser}
};

export default useUser